import React from "react";
import styles from "../styles/webStyles";
import { Grid } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useMediaQuery } from "react-responsive";
import PageTitle from "../components/Website/PageTitle";
import PageContainer from "../components/PageContainer";

const AtppTermsAndConditions = () => {
  const isPhone = useMediaQuery({ query: "(max-width: 812px)" });

  const sectionTitleStyle = {
    ...styles.subHeader,
    fontSize: isPhone ? "18px" : "22px",
    fontWeight: 900,
    marginTop: "1.5rem",
    marginBottom: "0.5rem",
  };

  return (
    <PageContainer>
      <Helmet>
        <title>Terms and Conditions | NTI</title>
      </Helmet>
      <PageTitle title="Terms And Conditions" />

      <div className="container">
        <div>
          <img
            src="/atpp-logo.png"
            alt="ATPP Logo"
            style={{
              width: "33%",
              height: "50%",
              objectFit: "contain",
              display: "block",
            }}
          />
        </div>
        <Grid container>
          <Grid items xs={12}>
            <div style={{ margin: "5rem 3rem" }}>
              <h2
                style={{
                  ...styles.subHeader,
                  fontSize: isPhone ? "20px" : "30px",
                  fontWeight: 900,
                  margin: 0,
                }}
              >
                Terms and Conditions
              </h2>

              <p style={{ marginTop: "0.75rem" }}>
                <strong>
                  Accelerated Teacher Professionalization Pathway (ATPP)
                </strong>
                <br />
                <strong>National Teachers’ Institute (NTI)</strong>
              </p>

              <h3 style={sectionTitleStyle}>1. Introduction</h3>
              <p>
                Welcome to the Accelerated Teacher Professionalization Pathway
                (ATPP), implemented by the National Teachers’ Institute (NTI).
                By accessing or using the ATPP Learning Management System (LMS),
                you agree to comply with and be bound by these Terms and
                Conditions. If you do not agree, you should not use the
                platform.
              </p>

              <h3 style={sectionTitleStyle}>2. Definitions</h3>
              <ul>
                <li>
                  <strong>Platform:</strong> The ATPP Learning Management System
                </li>
                <li>
                  <strong>User:</strong> Any individual accessing the platform
                  (teachers, administrators, partners)
                </li>
                <li>
                  <strong>Content:</strong> Courses, materials, videos,
                  assessments, and resources
                </li>
                <li>
                  <strong>NTI:</strong> National Teachers’ Institute (programme
                  owner and data controller)
                </li>
              </ul>

              <h3 style={sectionTitleStyle}>3. Eligibility</h3>
              <p>You must:</p>
              <ul>
                <li>
                  Be a registered participant in ATPP or authorized by NTI
                </li>
                <li>Provide accurate and complete registration information</li>
                <li>
                  Use the platform strictly for professional development
                  purposes
                </li>
              </ul>

              <h3 style={sectionTitleStyle}>4. User Accounts</h3>
              <ul>
                <li>
                  Users are responsible for maintaining the confidentiality of
                  login credentials
                </li>
                <li>You must not share your account with others</li>
                <li>
                  NTI reserves the right to suspend accounts for unauthorized
                  use
                </li>
              </ul>

              <h3 style={sectionTitleStyle}>5. Acceptable Use</h3>
              <p>You agree not to:</p>
              <ul>
                <li>Use the platform for unlawful purposes</li>
                <li>Upload false, harmful, or misleading information</li>
                <li>Attempt to hack, disrupt, or misuse the system</li>
                <li>
                  Share copyrighted course materials without authorization
                </li>
                <li>Impersonate another user</li>
              </ul>

              <h3 style={sectionTitleStyle}>6. Programme Participation</h3>
              <p>By enrolling in ATPP, you agree to:</p>
              <ul>
                <li>Actively participate in assigned modules</li>
                <li>Complete assessments honestly</li>
                <li>Comply with programme guidelines and timelines</li>
              </ul>
              <p>NTI reserves the right to:</p>
              <ul>
                <li>Monitor participation and performance</li>
                <li>Enforce programme standards</li>
              </ul>

              <h3 style={sectionTitleStyle}>7. Certification</h3>
              <ul>
                <li>
                  Certificates are issued upon successful completion of
                  programme requirements
                </li>
                <li>
                  NTI reserves the right to revoke certification in cases of
                  misconduct, fraud, or misrepresentation
                </li>
              </ul>

              <h3 style={sectionTitleStyle}>8. Intellectual Property</h3>
              <ul>
                <li>
                  All platform content remains the property of NTI or its
                  licensors
                </li>
                <li>
                  Users are granted a limited, non-transferable license to
                  access content for learning purposes only
                </li>
                <li>
                  Unauthorized reproduction, distribution, or commercial use is
                  prohibited
                </li>
              </ul>

              <h3 style={sectionTitleStyle}>9. Data Protection and Privacy</h3>
              <p>
                Your use of the platform is governed by our Data Privacy and
                Data Protection policies, in line with the Nigeria Data
                Protection Act 2023. By using the platform, you consent to:
              </p>
              <ul>
                <li>
                  Collection and processing of your data for programme delivery
                </li>
                <li>Use of anonymized data for reporting and improvement</li>
              </ul>

              <h3 style={sectionTitleStyle}>10. Platform Availability</h3>
              <p>
                NTI aims to ensure continuous platform availability but does not
                guarantee uninterrupted access. Maintenance, upgrades, or
                technical issues may result in temporary downtime.
              </p>

              <h3 style={sectionTitleStyle}>11. Limitation of Liability</h3>
              <p>To the extent permitted by law:</p>
              <ul>
                <li>
                  NTI shall not be liable for indirect, incidental, or
                  consequential damages
                </li>
                <li>
                  NTI is not responsible for losses arising from misuse of the
                  platform
                </li>
              </ul>

              <h3 style={sectionTitleStyle}>12. Third-Party Services</h3>
              <p>
                The platform may integrate third-party services (e.g., hosting,
                analytics). NTI is not responsible for the independent policies
                or actions of these providers.
              </p>

              <h3 style={sectionTitleStyle}>13. Suspension and Termination</h3>
              <p>NTI may suspend or terminate access if:</p>
              <ul>
                <li>Terms are violated</li>
                <li>Fraudulent or unethical behavior is detected</li>
                <li>Required programme obligations are not met</li>
              </ul>

              <h3 style={sectionTitleStyle}>14. Governing Law</h3>
              <p>
                These Terms are governed by the laws of the Federal Republic of
                Nigeria.
              </p>

              <h3 style={sectionTitleStyle}>15. Dispute Resolution</h3>
              <p>Disputes shall be resolved through:</p>
              <ul>
                <li>Good-faith negotiation</li>
                <li>Mediation (where applicable)</li>
                <li>Courts of competent jurisdiction in Nigeria</li>
              </ul>

              <h3 style={sectionTitleStyle}>16. Amendments</h3>
              <p>
                NTI reserves the right to update these Terms at any time. Users
                will be notified of significant changes via the platform.
              </p>

              <h3 style={sectionTitleStyle}>17. Contact Information</h3>
              <p>For inquiries regarding these Terms:</p>
              <p style={{ marginBottom: "0.5rem" }}>
                <strong>National Teachers’ Institute (NTI)</strong>
              </p>
              <ul style={{ marginTop: 0 }}>
                <li>
                  Address: <span>https://my.nti.edu.ng/</span>
                </li>
                <li>
                  Email: <span>info@nti.edu.ng</span>
                </li>
                <li>
                  Phone: <span>234-(0)62-887873</span>
                </li>
              </ul>
            </div>
          </Grid>
        </Grid>
      </div>
    </PageContainer>
  );
};

export default AtppTermsAndConditions;
